module.exports = __webpack_public_path__ + "static/img/logo_OwnersBookPlus.dc3ef2d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_OwnersBookPlus.svg
// module id = eR2b
// module chunks = 252